// Single source of truth for PUBLIC (prerendered, indexable) routes.
// Imported by BOTH App.tsx (BrowserRouter) and entry-server.tsx (StaticRouter).
// IMPORTANT: import public PAGE components only — no App, no auth/protected pages, no catch-all.
// (These pages do reach Clerk transitively via <Header>; that's fine — the SSR build aliases
// Clerk to a logged-out stub. What must NOT leak in is SignIn/SignUp/ClerkProvider, which the
// stub does not export.) Each router builds its own <Route element={<Component/>}>.
import type { ComponentType } from 'react'
import NewLandingPage from '../pages/NewLandingPage'
import DemoPage from '../pages/DemoPage'
import { PrivacyPage } from '../pages/PrivacyPage'
import { SecurityPage } from '../pages/SecurityPage'
import { TermsPage } from '../pages/TermsPage'
import BlogIndex from '../pages/blog/BlogIndex'
import BlogCategoryPage from '../pages/blog/BlogCategoryPage'
import BlogPostPage from '../pages/blog/BlogPostPage'
import ToolsIndex from '../pages/tools/ToolsIndex'
import ToolPage from '../pages/tools/ToolPage'

export interface PublicRoute {
  path: string
  Component: ComponentType
}

// Note: /blog/category/:cat is declared before /blog/:slug for clarity (React Router
// ranks static segments above params regardless).
export const publicRoutes: PublicRoute[] = [
  { path: '/', Component: NewLandingPage },
  { path: '/demo', Component: DemoPage },
  { path: '/privacy', Component: PrivacyPage },
  { path: '/security', Component: SecurityPage },
  { path: '/terms', Component: TermsPage },
  { path: '/blog', Component: BlogIndex },
  { path: '/blog/category/:cat', Component: BlogCategoryPage },
  { path: '/blog/:slug', Component: BlogPostPage },
  { path: '/tools', Component: ToolsIndex },
  { path: '/tools/:slug', Component: ToolPage },
]
